/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import convertOperator from 'cio/utils/operators/convert';
import BaseEditorComponent from 'cio/components/condition-list/edit/base';
import { serializeFilter as serializeAttributeFilter } from 'cio/utils/conditions/serialize/attribute';
import ObjectAttributeCondition, { ObjectAttributeSource } from 'cio/app-models/conditions/object-attribute';
import { allOperators as operators } from 'cio/utils/conditions-operators';
import { isBlank } from '@ember/utils';
import DS from 'ember-data';
import { ConditionType } from 'cio/utils/condition-types';

export default class ObjectAttribute extends BaseEditorComponent {
  @service store!: DS.Store;

  // external API
  condition: ObjectAttributeCondition | null = null;
  campaign = null;
  disabled = false;
  allowComparisonOperator = false;
  allowJsonOperators = false;
  showEventNameInEditor = true;
  onApply() {}
  variation = null;
  subLayout = null;

  // internal API
  get attributes() {
    let objectType;
    if (this.condition?.objectTypeId != null) {
      objectType = this.store.peekRecord('object-type', this.condition.objectTypeId);
    }
    return (
      objectType?.sentAttributes.map((attribute, index) => ({
        value: index,
        label: attribute,
      })) ?? []
    );
  }

  @action
  _onApply() {
    let condition = serializeAttributeFilter(
      this.condition as ObjectAttributeCondition,
      false,
      false,
      this.allowComparisonOperator,
    );
    if (
      this.condition?.objectAttributeSource === ObjectAttributeSource.RelationshipAttribute ||
      this.condition?.type === ConditionType.RelationshipAttribute
    ) {
      condition.type = ConditionType.RelationshipAttribute;
    } else {
      condition.type = ConditionType.ObjectAttribute;
    }
    condition.operator = convertOperator(condition.operator);
    // @ts-ignore: "onApply" not correctly typed, taken from parent Ember classic component class
    return this.onApply(condition);
  }

  @computed('condition.{name,value,operator,errors.operator}')
  // @ts-ignore
  get errors() {
    let errors = [];

    if (isBlank(this.condition?.name)) {
      errors.push("Object attribute can't be blank.");
    }

    let conditionOperator = convertOperator(this.condition?.operator, { to: 'attribute' });
    let operator = operators.findBy('value', conditionOperator);
    if (isBlank(this.condition?.value) && operator?.allowBlankPredicate === false) {
      errors.push("Value can't be blank.");
    }

    if ((this.condition?.errors.operator?.length ?? 0) > 0) {
      errors.push(this.condition?.errors.operator[0]);
    }

    return errors;
  }
}
